import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import styled from 'styled-components';

import { IconLike, IconDocument } from '../easyclaim.app.assets/index';
import {
	CenteredCircle,
	DetailContainer,
	Link,
	LinkContainer,
} from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { FinishedV2 } from './FinishedV2';

export const Finished = ({
	easyClaimCalculationResult,
	allowDownloadCalculationFileOnFinishedView,
}) => {
	const customerConfiguration = CustomerConfiguration();
	const useSolvdStyles = !!customerConfiguration?.useSolvdStyles;

	return (
		<div className="main-container">
			{useSolvdStyles && <FinishedV2 />}
			{!useSolvdStyles && (
				<>
					<div className="finished-centered-header">
						<h2 className="thanks-title">
							<FormattedMessage id="thanks.headline.first" />
						</h2>
					</div>
					<DetailContainer className="like-container">
						<CenteredCircle
							className="like-circle"
							size="6rem"
							borderColor={customerConfiguration?.successColor ?? theme.colors.success}
							borderStyle="solid"
							borderWidth="3px"
						>
							<StyledLikeIcon className="like-icon" />
						</CenteredCircle>
						<Paragraph className="thanks-container word-break-auto">
							<FormattedMessage id="thanks.paragraph.first" />
						</Paragraph>
						{easyClaimCalculationResult?.reportUrl &&
							allowDownloadCalculationFileOnFinishedView && (
								<LinkContainer>
									<Link
										onClick={() => {
											if (easyClaimCalculationResult?.reportUrl) {
												window.open(easyClaimCalculationResult.reportUrl, '_blank');
											}
										}}
									>
										<StyledCalculationIcon />
										<Paragraph>
											<Label>
												<FormattedMessage id="thanks.calculationPDF" />
											</Label>
										</Paragraph>
									</Link>
								</LinkContainer>
							)}
					</DetailContainer>
				</>
			)}
		</div>
	);
};

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	text-align: center;
`;

const StyledLikeIcon = styled(IconLike)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

const Label = styled.div`
	flex-grow: 1;
	flex-shrink: 1;
`;

const StyledCalculationIcon = styled(IconDocument)`
	height: 2rem;
	width: 2rem;
	flex-grow: 0;
	flex-shrink: 0;
	margin-right: 0.35rem;
	margin-bottom: 1rem;
`;
